export default __webpack_public_path__ + "static/media/answer.16004e01.svg";